const DEFAULT_FALLBACK_MESSAGE = "An unexpected error occurred";

export const toErrorWithMessage = (
  error,
  fallbackMessage = DEFAULT_FALLBACK_MESSAGE,
) => {
  const normalizedFallback =
    typeof fallbackMessage === "string" && fallbackMessage.trim().length > 0
      ? fallbackMessage
      : DEFAULT_FALLBACK_MESSAGE;

  if (error instanceof Error) {
    if (!error.message) {
      error.message = normalizedFallback;
    }
    return error;
  }

  if (error && typeof error === "object" && "message" in error) {
    const message = error.message;
    if (typeof message === "string" && message.trim().length > 0) {
      return new Error(message);
    }
  }

  if (typeof error === "string" && error.trim().length > 0) {
    return new Error(error);
  }

  return new Error(normalizedFallback);
};
